import React from "react";
import { SitePage, PageHead } from "./SiteChrome";

const PRIVACY = {
  label: "Privacy Policy",
  title: "Privacy Policy",
  updated: "Last updated: August 2026",
  sections: [
    { h: "1. Who we are", p: "CamelionAI LLC (\"CamelionAI\", \"we\") operates camelionai.com and the CamelionAI platform family. This policy describes how we handle information collected through this website." },
    { h: "2. Information we collect", p: "Through this website we collect only what you choose to provide: your name, email address, organization, professional role, inquiry type, and message when you contact us or join a waitlist. We do not collect patient information through this website, and you must not submit protected health information (PHI) through any form on this site." },
    { h: "3. How we use it", p: "We use contact and waitlist information solely to respond to your inquiry, administer beta programs, and communicate about CamelionAI products. We do not sell personal information." },
    { h: "4. Storage and retention", p: "Submissions are stored on managed infrastructure with access limited to CamelionAI personnel. We retain inquiries for as long as needed to serve the relationship, and delete them on verified request." },
    { h: "5. Cookies and analytics", p: "This website uses only the technical cookies required to operate. We do not run third-party advertising trackers." },
    { h: "6. Your choices", p: "You may request access to, correction of, or deletion of your submitted information at any time by emailing ronik@camelionai.com." },
    { h: "7. Platform products", p: "The ProsthoAI, ZidaMD, and ReimbursePro applications are governed by their own agreements and privacy terms appropriate to their deployment contexts, including healthcare data-protection requirements where applicable." },
    { h: "8. Changes", p: "We will post any changes to this policy on this page with an updated date." },
    { h: "9. Contact", p: "Privacy questions: ronik@camelionai.com — CamelionAI LLC, Boca Raton, FL." },
  ],
};

const TERMS = {
  label: "Terms of Use",
  title: "Terms of Use",
  updated: "Last updated: August 2026",
  sections: [
    { h: "1. Acceptance", p: "By accessing camelionai.com you agree to these Terms of Use. If you do not agree, please do not use this website." },
    { h: "2. Informational purpose", p: "This website describes CamelionAI products and company information. Content is provided for general information only and may change without notice." },
    { h: "3. No medical advice", p: "Nothing on this website constitutes medical, dental, legal, billing, or professional advice. CamelionAI platforms provide decision support; all clinical and administrative decisions remain the responsibility of qualified professionals." },
    { h: "4. No PHI", p: "You must not submit patient information or protected health information through this website. Forms on this site are not intended or configured for PHI." },
    { h: "5. Beta programs", p: "Beta access is offered at CamelionAI's discretion and governed by separate beta agreements. Beta environments operate on synthetic data during evaluation." },
    { h: "6. Intellectual property", p: "CamelionAI, ProsthoAI, ZidaMD, ReimbursePro, ARIA, and associated marks, logos, and content are the property of CamelionAI LLC. Patent pending, USPTO. You may not reproduce site content without written permission." },
    { h: "7. Acceptable use", p: "You agree not to misuse this website, attempt unauthorized access, or interfere with its operation." },
    { h: "8. Disclaimer of warranties", p: "This website is provided \"as is\" without warranties of any kind, express or implied, to the maximum extent permitted by law." },
    { h: "9. Limitation of liability", p: "To the maximum extent permitted by law, CamelionAI LLC is not liable for indirect, incidental, or consequential damages arising from use of this website." },
    { h: "10. Governing law", p: "These terms are governed by the laws of the State of Florida, USA, without regard to conflict-of-law rules." },
    { h: "11. Contact", p: "Questions about these terms: ronik@camelionai.com." },
  ],
};

export default function LegalPage({ kind }) {
  const doc = kind === "privacy" ? PRIVACY : TERMS;
  return (
    <SitePage testId={`legal-${kind}-page`}>
      <PageHead label={doc.label} title={doc.title} lede={doc.updated} />
      <div className="sp-legal-flag" data-testid="legal-draft-notice">
        Draft for attorney review — not final legal advice.
      </div>
      <div className="sp-legal">
        {doc.sections.map((s) => (
          <section key={s.h}>
            <h3>{s.h}</h3>
            <p>{s.p}</p>
          </section>
        ))}
      </div>
    </SitePage>
  );
}
